<template>
  <div class="filter-item">
    <div class="md-layout md-gutter">
      <div class="md-layout-item">
        <md-field>
          <label>Поиск</label>
          <md-input v-bind:value="searchText()"
                    v-on:input="searchText($event)"  v-on:keyup.enter="searchChange" md-dense></md-input>
        </md-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'search',
  data () {
    return {
      value: null
    }
  },
  methods: {
    searchChange () {
      this.$emit('changeFilter')
    },
    searchText (cl) {
      if (typeof (cl) !== 'undefined') {
        this.$store.state.filtersShop.q = cl
      }
      return this.$store.state.filtersShop.q
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/filters/shop/search.vue